import { render, staticRenderFns } from "./DOD_Intro1.vue?vue&type=template&id=1409ddc5&scoped=true"
import script from "./DOD_Intro1.vue?vue&type=script&lang=js"
export * from "./DOD_Intro1.vue?vue&type=script&lang=js"
import style0 from "./DOD_Intro1.vue?vue&type=style&index=0&id=1409ddc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1409ddc5",
  null
  
)

export default component.exports